import { lazy } from 'react';

const InviteMemberModal = lazy(() => import('./components/InviteMemberModal'));
const PendingInvitesModal = lazy(() =>
  import('./components/PendingInvitesModal'),
);
const MemberRoleModal = lazy(() => import('./components/MemberRoleModal'));
const MemberStatusModal = lazy(() => import('./components/MemberStatusModal'));

export default {
  INVITE_MEMBER_MODAL: InviteMemberModal,
  MEMBER_ROLE_MODAL: MemberRoleModal,
  MEMBER_STATUS_MODAL: MemberStatusModal,
  PENDING_INVITES_MODAL: PendingInvitesModal,
};
